import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=71ef1b62&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"
import style0 from "./Photo.vue?vue&type=style&index=0&id=71ef1b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef1b62",
  null
  
)

export default component.exports